<template>
  <div class="languages" v-if="canShowLanguagesSelector()">
    <div class="lang-selector">
      <label class="sr-only" for="select_lang">{{ $t('header.availabilityAdjust.changeLanguage') }}</label>
      <select name="langs" id="select_lang" v-model="selectedLang">
        <option v-for="(lang, index) in languagesList" :value="lang" :selected="isLanguageActive(lang)" :key="index">
          {{ getLangLabel(lang) }}
        </option>
      </select>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { LANGUAGES_LABEL_LIST } from '@/base/const/lang.const'

defineOptions({ name: 'Languages' })

const store = useStore()

const selectedLang = ref(null)

const languagesList = computed(() => store.getters.getAvailableLanguagesList)
const storeCurrentLang = computed(() => store.state.lang.current)

watch(
  storeCurrentLang,
  (newValue) => {
    if (newValue !== selectedLang.value) {
      selectedLang.value = newValue
    }
  },
  { immediate: true }
)

watch(selectedLang, (newValue, oldValue) => {
  if (oldValue && newValue !== storeCurrentLang.value) {
    store.dispatch('setLanguage', newValue)
  }
})

function isLanguageActive(lang) {
  return lang === selectedLang.value
}

function getLangLabel(lang) {
  return LANGUAGES_LABEL_LIST[lang]
}

function canShowLanguagesSelector() {
  return languagesList.value.length > 1
}
</script>
